// antd
import type {TablePaginationConfig} from 'antd/es/table';
import type {DefaultOptionType} from 'antd/es/select';
interface SelectionItem {
  id: number
  text: string
}

interface SelectItem<T,D> extends DefaultOptionType{
  key:number    // id of item
  value:string  // string value of item
  data:T        // Complete array of the user selected item in the dropdown-
  record:D      // Complete record of the row that was clicked-
  index:number  // Index value of the row that was clicked-
}

// Generic DataSource for an antd Table
interface GenericOptions<T> {
  loading: boolean
  data: T[]
}

const defaultGenericOptions = {
  loading: false,
  data: []
}

const defaultSelectionItem: SelectionItem = {
  id: 1, 
  text: "Loading"
}

// const defaultGenericSelection =  {
//     loading: true,
//     data: [{ id: "Loading", text: "Loading" }],
// }

const DefaultPagination: TablePaginationConfig = {
    pageSize: 5,
    responsive: false,
    size: "small", // 'default' | 'middle' | 'small'
    position: ['bottomRight'],
    showSizeChanger: false,
    // Page controls only, and only once they are needed- antd renders the pager even when
    // everything fits on one page (hideOnSinglePage defaults to false), so without this a table
    // holding a single row still shows a "1" button- With pageSize 5 the control now appears
    // only once there are more than 5 rows-
    hideOnSinglePage: true
}

const noImagePathUrl =
        require("../../assets/dark-theme/icons/no-image.svg").default;
interface ImageLoad {
  loading: boolean
  type: string
  id: number
  url: any
}

const defaultImageLoad: ImageLoad = {
  loading: false,
  type: "noImage",
  id: -1,
  url: noImagePathUrl
}

export {
  DefaultPagination,
  defaultSelectionItem,
  defaultGenericOptions,
  defaultImageLoad,
};

export type {
  SelectionItem,
  GenericOptions,
  ImageLoad,
  SelectItem,
}